import AdminControlTypeDetail from './AdminControlTypeDetail'
export default AdminControlTypeDetail
